export default class MediaToUploadObject {
  constructor(id, name, path, toggledForUpload = false) {
    this.id = Number(id);
    this.name = String(name);
    this.path = this.getFullFilePath(path);
    this.extn = this.name.split(".").pop();
    this.mimeType = this.getMimeType(this.extn);
    this.toggledForUpload = Boolean(toggledForUpload);
    this.hasErrors = Boolean(false);
    this.hasUploaded = Boolean(false);
    this.errorMessage = String("");
  }
  getFullFilePath(path) {
    return path + "/" + this.name;
  }
  getMimeType(extn) {
    return "image/" + this.extn;
  }
  static toJSON() {
    id: this.id;
    name: this.name;
    path: this.path;
    extn: this.extn;
    mime_type: this.mimeType;
    toggled_for_upload: this.toggledForUpload;
    has_errors: this.hasErrors;
    has_uploaded: this.hasUploaded;
    error_message: this.errorMessage;
  }
}
